import React from 'react'

export default function AdvertiserDashboardRoutes() {

  return (
    <div>
      AdvertiserDashboardRoutes
    </div>
  )
}